// Minimal pack for pages that don't need the full application bundle (auth)
// but must still carry Turbo for Hotwire Native: the native shell refuses to
// render pages where Turbo is absent ("configuration error" screen).
const { Turbo } = require('@hotwired/turbo-rails')
// Same form policy as application.js: classic full-page submits — Devise
// re-renders the form with 200 on failed login, which Turbo Drive rejects.
Turbo.setFormMode('optin')
